<template>
    <div class="modal" :class="{ 'is-active': isActive }">
        <div class="modal-background" @click="closeModal"></div>
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">Translation!</p>
                <button class="delete" aria-label="close" @click="closeModal"></button>
            </header>
            <section class="modal-card-body">
                <div class="columns">
                    <div class="column">
                        <figure class="image">
                            <img :src="bid.pictures.split('#')[0]">
                        </figure>
                    </div>
                    <div class="column">
                        <div class="field">
                            <div class="control">
                        <textarea class="textarea" placeholder="Please wright translation"
                                  v-model="translation.body"
                        ></textarea>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <footer class="modal-card-foot">
                <button class="button is-primary"
                        v-bind:class="{ 'is-loading': isLoading }"
                        v-if="!isTranslated"
                        @click="createNewTranslation">Post</button>
                <button class="button is-info"
                        v-bind:class="{ 'is-loading': isLoading }"
                        v-if="isTranslated"
                        @click="updateTranslation">Update</button>
                <button class="button" @click="closeModal">Cancel</button>
            </footer>
        </div>
    </div>
</template>

<script>
    import apiTranslations from './../../api/apiTranslations.js'
    export default {
        props: ['bid'],
        data() {
           return {
              isLoading: false,
              translation: {
                  lot_id: this.bid.lot_id,
                  body: null
              }
           }
        },
        computed: {
            isActive() {
                return this.$store.getters.getTranslateModalStatus(this.bid.id)
            },
            isTranslated() {
                return this.bid.lot.translation !== null
            }
        },
        methods: {
            closeModal() {
                this.$store.dispatch('changeTranslateModalStatus', {status: false, bidId: ''})
            },
            createNewTranslation() {
                this.isLoading = true
                apiTranslations
                    .placeTranslationRequest(this.translation)
                    .then((response) => {
                        this.translation = response.data
                        this.isLoading = false
                        this.bid.lot.translation = response.data
                    })
                    .catch(error => console.log(error))
            },
            updateTranslation() {
                this.isLoading = true
                apiTranslations
                    .updateTranslationRequest(this.translation)
                    .then((response) => {
                        this.translation = response.data
                        this.isLoading = false
                        this.bid.lot.translation = response.data
                    })
                    .catch(error => console.log(error))
            }
        },
        created () {
            if (this.bid.lot.translation !== null) {
                this.translation.body = this.bid.lot.translation.body
            }
        }
    }
</script>

<style scoped>
    .modal-card {
        width: 90%;
    }
    .image {
        padding-bottom: 20px;
        float: left;
    }
    .textarea {
        min-height: 600px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Bids/TranslateModal.vue